(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/slicedToArray', 'babel-runtime/helpers/toArray', '../path/consts', '../util/lang', '../path/toPath'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/slicedToArray'), require('babel-runtime/helpers/toArray'), require('../path/consts'), require('../util/lang'), require('../path/toPath'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.slicedToArray, global.toArray, global.consts, global.lang, global.toPath);
    global.get = mod.exports;
  }
})(this, function (exports, _slicedToArray2, _toArray2, _consts, _lang, _toPath) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.get = undefined;

  var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

  var _toArray3 = _interopRequireDefault(_toArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  /**
  * Gets the value at <code>path</code> of <code>obj</code>.
  * @memberof core
  * @param {*} obj The object.
  * @param {string|Array} path The path of the property to get.
  * @param {*} defaultValue The default value.
  * @return {*} Returns the value or <code>defaultValue</code>.
  * @example get({ nested: { prop: 'val' } }, 'nested.prop') // => 'val'
  * @example get({ nested: { prop: 'val' } }, 'nested.unknown', 'default') // => 'default'
  * @since 1.0.0
   */


  function get(obj, path, defaultValue) {
    function walkPath(curObj, remPath) {
      if (remPath.length === 0) return curObj === undefined ? defaultValue : curObj;
      if ((0, _lang.isNil)(curObj)) return defaultValue;

      var _remPath = (0, _toArray3.default)(remPath),
          _remPath$ = (0, _slicedToArray3.default)(_remPath[0], 2),
          prop = _remPath$[1],
          pathRest = _remPath.slice(1);

      return walkPath(curObj[prop], pathRest);
    }

    var parsedPath = (0, _toPath.toPath)(path);
    if (parsedPath.some(function (_ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
          propType = _ref2[0];

      return propType !== _consts.prop && propType !== _consts.index;
    })) throw TypeError('get supports only properties and array indexes in path');
    return walkPath(obj, parsedPath);
  }

  exports.get = get;
});